import angular              from 'angular';

import { CeleroApiKeyCtrl }         from './celero.api-key';
import { CeleroManualPaymentCtrl }  from './celero.manual-payment';
import { CeleroStates }             from './celero.states.ajs';
import { CeleroService }            from './celero.service';
import { CeleroSettingsCtrl }       from './celero.settings';
import { CeleroTerminalCtrl }       from './celero.terminal';
import { CeleroTerminalsCtrl }      from './celero.terminals';
import { CeleroTerminalsDirective } from './celero.terminals.directive';
import { CeleroTokenizerCtrl }      from './celero.tokenizer';
import { CeleroTokenizerDirective } from './celero.tokenizer.directive';

angular.module('workshop.celero', [])
.config(CeleroStates)
.controller('CeleroApiKeyCtrl', CeleroApiKeyCtrl)
.controller('CeleroManualPaymentCtrl', CeleroManualPaymentCtrl)
.controller('CeleroSettingsCtrl', CeleroSettingsCtrl)
.controller('CeleroTerminalCtrl', CeleroTerminalCtrl)
.controller('CeleroTerminalsCtrl', CeleroTerminalsCtrl)
.controller('CeleroTokenizerCtrl', CeleroTokenizerCtrl)
.directive('celeroTerminals', CeleroTerminalsDirective)
.directive('celeroTokenizer', CeleroTokenizerDirective)
.factory('Celero', CeleroService);
